import ArrivalRatesPerServiceTable from "../../tables/daily/OrganizationArrivalRatesPerServiceTable";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../../store/reportEnterpriseInsights";

const OrganizationArrivalRatesPerService = ({ reportIndex, data, renderConfig }) => {
  const insights = buildArrivalInsights(data, { scopeLabel: "Service" });

  return (
    <>
      <EnterpriseReportSummary
        title="Daily Service Arrival Demand Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      {data.map((serviceData, index) => {
        return (
          <>
            <ArrivalRatesPerServiceTable
              index={index}
              reportIndex={reportIndex}
              serviceData={serviceData}
              renderConfig={renderConfig}
            />
          </>
        );
      })}
    </>
  );
};

export default OrganizationArrivalRatesPerService;
